import { useSelector } from "react-redux";
import { Box, Grid, Typography, Avatar, Divider, useTheme } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import { Card } from "../../ui";
import formatPhoneNumber from "../../../helpers/formatPhoneNumber";
import { isLoading, isSuccess } from '../../../constants/redux.constants';
import { ProfileSkeleton } from "./skeletons";


const statusList = {
  'Р': 'Работает',
  'О': 'В отпуске',
  'Н': 'Уволен',
}

const formatPhoneWithMask =  (phones) => {
  let result = []
  if (!phones) return result

  const splitPhones = phones.split(';')

  for(let phone of splitPhones) {
    // Применяем существующую функцию форматирования
     const formatted = formatPhoneNumber(phone, '+7', 'RU', 10);

    result.push(formatted);
  }

  return result.join(' / ')
}


function ProfileTab() {
  const theme = useTheme();

  const { profile, profileLS } = useSelector(state => state.profile)


  return (
    <Box>
      {isLoading(profileLS) && (<ProfileSkeleton />)} 

      {isSuccess(profileLS) && (
        <>
        <Card sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          minWidth: '100%', 
          border: `1px solid ${theme.palette.OICO.stone[200]}`,
          p: { xs: 2, md: 5 },
          mb: { xs: 1, md: 2 }
          }}
        >
          <Grid sx={{ display: 'flex', alignItems: { xs: 'start', md: 'center' }, gap: { xs: 2, md: 3 } }} > 
            <Avatar sx={{ color: 'white', bgcolor: theme.palette.OICO.purple.main, width: { xs: 50, md: 100 }, height: { xs: 50, md: 100 } }}>
              <Typography sx={{ fontSize: { xs: 26, md: 62 } }}>{profile.username?.charAt(0).toUpperCase()}</Typography>
            </Avatar>

            <Grid sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 1, md: 1.5 } }}>
              <Typography sx={{ fontSize: { xs: 18, md: 38 }, fontWeight: 500 }}>{profile.username}</Typography>
              <Grid sx={{ display: 'flex', gap: { xs: 0.5, md: 3 }, flexDirection: { xs: 'column', md: 'row' } }}>
                <Grid sx={{ display: 'flex', gap: 0.7 }}>
                  <Typography sx={{ fontSize: 14, color: theme.palette.grey.main }}>Логин:</Typography>
                  <Typography sx={{ fontSize: 14, fontWeight: 600}}>{profile.ref_users.LOGIN}</Typography>
                </Grid>
                <Grid sx={{ display: 'flex', gap: 0.7 }}>
                  <Typography sx={{ fontSize: 14, color: theme.palette.grey.main }}>Статус:</Typography>
                  <Typography sx={{ fontSize: 14, fontWeight: 600 }}>{statusList[profile.ref_users.STATUS] || 'неизвестно'}</Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Card>

        <Grid sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' } }}  gap={{ xs: 1, md: 2 }}>  

          <Grid container xs={12} md={8} gap={{ xs: 1, md: 2 }}>
            <Card sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              minWidth: '100%', 
              border: `1px solid ${theme.palette.OICO.stone[200]}`,
              p: { xs: 2, md: 5 }
            }}
            >
              <Grid>
                <Typography sx={{ fontSize: 14, color: theme.palette.grey.main }}>Должность</Typography>
                <Typography sx={{ fontSize: 14, fontWeight: 600}}>{profile.ref_users.POSITION ? profile.ref_users.POSITION : 'Не указана'}</Typography>              
              </Grid>
            </Card>

            <Card sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              minWidth: '100%', 
              border: `1px solid ${theme.palette.OICO.stone[200]}`,
              p: { xs: 2, md: 5 }
            }}
            >
              <Grid>
                <Typography sx={{ fontSize: 14, color: theme.palette.grey.main }}>Телефон</Typography>
                <Typography sx={{ fontSize: 14 }}>{profile.ref_users.PHONES ? formatPhoneWithMask(profile.ref_users.PHONES) : <span style={{ fontWeight: 500 }}>Не указан</span>}</Typography>   

                <Divider sx={{ bgcolor: theme.palette.OICO.neutral[300], my: { xs: 1.5, md: 3 } }} />        

                <Typography sx={{ fontSize: 14, color: theme.palette.grey.main }}>Почта</Typography>
                <Typography sx={{ fontSize: 14, fontWeight: 500 }}>{profile.ref_users.EMAIL ? profile.ref_users.EMAIL  : 'Не указана'}</Typography>   
              </Grid>
            </Card>

            <Card sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              minWidth: '100%', 
              border: `1px solid ${theme.palette.OICO.stone[200]}`,
              p: { xs: 2, md: 5 }
            }}
            >
              <Grid>
                <Typography sx={{ fontWeight: 500, fontSize: 14, pb: { xs: 2, md: 3 } }}>Компании</Typography>

                {profile.ref_users_cnts?.map((cnt, index) => (
                  <Box key={cnt.owner_id}>
                    <Typography sx={{ fontSize: 14 }}>{cnt.short_name}</Typography>
                    {index !== profile.ref_users_cnts.length - 1 && (
                      <Divider sx={{ bgcolor: theme.palette.OICO.neutral[300], my: { xs: 2, md: 3 } }} />    
                    )}
                  </Box>
                ))}
                
              </Grid>
            </Card>
          </Grid>

          <Grid xs={12} md={4}>
            <Card sx={{ 
              display: 'flex', 
              flexDirection: 'row',
              gap: { xs: 1, md: 1 },
              minWidth: '100%', 
              border: `1px solid ${theme.palette.OICO.stone[200]}`,
              p: { xs: 2, md: 5 },
            }}

            >
              <InfoOutlined sx={{ fill: theme.palette.grey.main, cursor: 'default' }} />
              <Grid>
                <Typography sx={{ fontWeight: 500, fontSize: 14 }}>Ошибка в данных?</Typography>
                <Typography sx={{ color: theme.palette.grey.main, fontSize: 14 }}>Сообщите своему руководителю</Typography>
              </Grid>
            </Card> 
          </Grid>

        </Grid>
        </>
      )}
    </Box>
  )
}

export default ProfileTab